var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartFilled({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "heart-filled-svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    className: "svg heart-filled",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16,30a1.88,1.88,0,0,1-1.38-.64L2.53,17A9.09,9.09,0,0,1,.19,12.81,10.3,10.3,0,0,1,.4,8,8.42,8.42,0,0,1,3.07,4.06,8.09,8.09,0,0,1,6.91,2.14a9,9,0,0,1,4.16.32A9.49,9.49,0,0,1,14.7,4.81L16,6.09l1.28-1.28a10.1,10.1,0,0,1,3.63-2.35A8.05,8.05,0,0,1,28.9,4h0a8,8,0,0,1,2.67,4,9.2,9.2,0,0,1,.21,4.8A8,8,0,0,1,29.54,17L17.48,29.46A2,2,0,0,1,16,30Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartFilled);
export default __webpack_public_path__ + "static/media/heart-filled.05fe425dda3e5c8e2a7d96b3fd4387d7.svg";
export { ForwardRef as ReactComponent };